import { Storage } from '~/shared/utils/storage/storage';
import { useLocalStorageString } from '../utils';

export default function useBasketTimer() {
    return useLocalStorageString(Storage.basketTimer, undefined);
}
